import axios from "axios";

export const getToken = () => localStorage.getItem("kryvo_admin_token");
export const setToken = (t) => localStorage.setItem("kryvo_admin_token", t);
export const clearToken = () => localStorage.removeItem("kryvo_admin_token");

export const adminApi = () =>
    axios.create({
        baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
        headers: { Authorization: `Bearer ${getToken()}` },
    });

export const formatApiError = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};
